import PropTypes from "prop-types";
import styled from "styled-components";

export const Th = styled.th`
    font-weight: 400;
    padding: ${props => props.padding || "6px 2px 6px 8px"};
    border-bottom: 1px solid ${props => props.theme.primary};
    text-align: ${props => props.align};
    width: ${props => props.width};
    color: ${props => props.theme.primary};
    ${props =>
        props.clickable &&
        `cursor: pointer;
    -webkit-touch-callout: none;`};
`;

Th.defaultProps = {
    align: "right",
    width: "auto",
    clickable: false
};

Th.propTypes = {
    align: PropTypes.oneOf(["left", "right", "center", "justify"]),
    width: PropTypes.string,
    clickable: PropTypes.bool
};
